import { newSpecPage } from '@stencil/core/testing';
import { SallaReviewsSummary } from '../salla-reviews-summary';

describe('salla-reviews-summary', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [SallaReviewsSummary],
      html: `<salla-reviews-summary></salla-reviews-summary>`,
    });
    expect(page.root).toEqualHtml(`
      <salla-reviews-summary>
        <mock:shadow-root>
          <slot></slot>
        </mock:shadow-root>
      </salla-reviews-summary>
    `);
  });
});
